import addresses from "constants/contract";
import { Address } from "config/constants/types";
import { activeNetwork, networks } from "config/networkConfig";

export const getAddress = (address: Address): string => {
  const chainId = networks[activeNetwork]["chainId"];
  return address[chainId];
};

export const getLockUpAddress = () => {
  return getAddress(addresses.LockUp);
};

export const getTokenAddress = () => {
  return getAddress(addresses.DividendToken);
};
export const getRouterAddress = () => {
  return getAddress(addresses.LpTokenRouter);
};
export const getWBNBAddress = () => {
  return getAddress(addresses.WBNB);
};

export const getUSDTAddress = () => {
  return getAddress(addresses.USDT);
};

export const getMulticallAddress = () => {
  return getAddress(addresses.multiCall);
};

export const getDrivenFarmAddress = () => {
  return getAddress(addresses.DrivenFarm);
};


